import { useTheme } from 'styled-components'
import { Link } from 'react-router-dom'
import { NavigationDesktopWrapper, NavigationLinksContent, NavigationLogo } from './NavigationDesktop.styled'
import { NavigationLinks } from './NavigationLinks'
import { publicRoutes } from '../../router'
import { FlexContainer } from '../common/Wrappers/Containers'
import { Menu } from '../Menu/Menu'
import { useResize } from '../../contexts/resize/useResize'

export const NavigationDesktop = () => {
  const theme = useTheme()
  const { width } = useResize()

  const useMobileLogo = width < 730

  return (
    <NavigationDesktopWrapper id="navigation-desktop-wrapper">
      <NavigationLinksContent id="navigation-links-content">
        <Link to={publicRoutes.legacyRhinoClaim} className="logo-link">
          <NavigationLogo src={useMobileLogo ? theme.assets.solo : theme.assets.logo} alt="rhino.fi logo" />
        </Link>
        <NavigationLinks />
      </NavigationLinksContent>
      <FlexContainer $gap="16px">
        <Menu />
      </FlexContainer>
    </NavigationDesktopWrapper>
  )
}
